module.exports = __webpack_public_path__ + "static/img/S1-MME-logo.43dba96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/S1-MME-logo.svg
// module id = FUhT
// module chunks = 1